import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function CommonModal(props) {

  return (
    <>
      <Modal show={props.show} onHide={props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.message}</Modal.Body>
        <Modal.Footer>
         {props.footer}
        </Modal.Footer>
      </Modal>
    </>
  )
}


